<template>
	<q-card
		class="full-width shadow-transition full-height relative-position card-course cursor-pointer"
		:class="class_hover"
		@mouseover="setClassHover('mouseover')"
		@mouseleave="setClassHover('mouseleave')"
	>
		<div class="q-img">
			<div class="img">
				<img
					class="full-width"
					:src="getImage"
					@error="getImageError"
					:alt="getAltImage"
					@click="openCourse()"
				/>
			</div>
		</div>

		<q-card-section @click="openCourse()">
			<div class="text-subtitle2 code-course q-pb-none" style="height: 3.3vh" v-if="hasCode">
				{{ course.code || '' }}
			</div>

			<div class="text-subtitle2 title-course">{{ course.title }}</div>
		</q-card-section>

		<q-card-actions class="text-grey-5 absolute-bottom">
			<div class="row full-width">
				<div class="col-12">
					<q-linear-progress
						rounded
						style="height: 6px"
						:color="getProgressBarColor"
						:value="course.group_training_user_result_date ? 1 : course.user_progress / 100"
						v-if="!has_not_bar"
					/>
				</div>

				<div class="col-12 text-center q-my-sm">
					<q-btn size="sm" dense flat no-caps icon="fal fa-trophy" v-if="$hasScore()">
						<q-tooltip>
							{{ $t('points', { count: course.score }) }}
						</q-tooltip>
						<span class="q-pl-xs">{{ course.score }}</span>
					</q-btn>

					<q-btn size="sm" dense flat no-caps icon="fal fa-clock" v-if="course.workload">
						<q-tooltip>
							{{ $t('workload') }}
						</q-tooltip>
						<span class="q-pl-xs">{{ course.workload }}</span>
					</q-btn>

					<q-btn
						size="sm"
						dense
						flat
						no-caps
						:icon="course.starred ? 'fas fa-star' : 'far fa-star'"
						@click="toggleReviews()"
						v-if="useReviews"
					>
						<q-tooltip>
							{{ $t('reviews') }}
						</q-tooltip>

						<span class="q-pl-xs">{{ course.avg_stars.toFixed(1) }}</span>
					</q-btn>
				</div>

				<div class="col-12 text-center">
					<q-btn
						size="sm"
						dense
						flat
						no-caps
						:icon="course.liked ? 'fas fa-thumbs-up' : 'far fa-thumbs-up'"
						@click="likeCourse()"
					>
						<q-tooltip>
							<template v-if="!course.liked">
								{{ $t('like') }}
							</template>

							<template v-else>
								{{ $t('unlike') }}
							</template>
						</q-tooltip>

						<span class="q-pl-xs">{{ course.likes }}</span>
					</q-btn>

					<q-btn
						size="sm"
						dense
						flat
						no-caps
						:icon="course.favorited ? 'fas fa-heart' : 'far fa-heart'"
						@click="favoriteCourse()"
					>
						<q-tooltip>
							<template v-if="!course.favorited">
								{{ $t('favorite_course') }}
							</template>

							<template v-else>
								{{ $t('unfavorite_course') }}
							</template>
						</q-tooltip>
					</q-btn>
				</div>
			</div>
		</q-card-actions>

		<q-tooltip
			v-if="checkTrailEnrolled"
			anchor="center middle"
			self="center middle"
			content-class="bg-primary"
			content-style="font-size: 16px"
		>
			{{ $t('you_need_to_enroll_before_starting_this_content') }}
		</q-tooltip>

		<q-tooltip
			v-if="!checkTrailEnrolled && is_blocked && $route.name === 'trail'"
			anchor="center middle"
			self="center middle"
			content-class="bg-primary"
			content-style="font-size: 16px"
		>
			<span v-if="content.is_hierarchy_blocked">
				{{
					`${$t('you_need_to_finish_the_content')} ${content.parent_title} ${$t(
						'before_starting_this'
					)}`
				}}
			</span>

			<span v-else-if="content.availability_date_block">
				{{
					`${$t('this_content_will_be_available_on')} ${$dateUtil.fDateNoTimezone(
						content.availability_date
					)}`
				}}
			</span>
		</q-tooltip>

		<q-inner-loading :showing="loading">
			<q-spinner-facebook size="1rem" color="text-blue-grey-4" />
		</q-inner-loading>
	</q-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'CoursesCardDesktop',

	props: ['course', 'origin', 'trail_title', 'is_blocked', 'trail', 'content', 'has_not_bar'],

	data() {
		return {
			class_hover: '',
			loading: false,
		}
	},

	computed: {
		...mapGetters({
			clients: 'params/clients',
			country_areas: 'site_lists/country_areas',
			groups_user: 'site_lists/groups_user',
			id_user_client_selected: 'common/id_user_client_selected',
		}),

		getClientByIdClientSelected() {
			return this.clients.find((obj) => obj.id == this.id_user_client_selected)
		},

		getImage() {
			const img = this.course.group_training_images.find((obj) => {
				return obj.name ? obj.name === 'small' : obj.image_name === 'small'
			})
			if (img && img.image_url) return img.image_url
			else {
				const obj = this.getClientByIdClientSelected
				return obj.group_training_placeholder
			}
		},

		getAltImage() {
			if (this.course.group_training_image_alt_texts?.length) {
				return this.course.group_training_image_alt_texts[0].alt_text
			}
			const obj = this.getClientByIdClientSelected
			if (obj) {
				if (obj.group_training_placeholder_alt_text != '')
					return obj.group_training_placeholder_alt_text
			} else return ''
		},

		checkTrailEnrolled() {
			if (this.trail && this.useTrailSubscription) {
				if (this.trail.is_mandatory || this.trail.is_self_subscribed || this.trail.is_subscribed)
					return false
				else return true
			} else return false
		},

		useTrailSubscription() {
			const obj = this.getClientByIdClientSelected
			return obj ? obj.use_trail_subscription : false
		},

		getProgressBarColor() {
			if (
				this.content.user_result === 'approved' ||
				this.content.group_training_user_result_status == 1
			)
				return 'green-5'
			if (
				this.content.user_result === 'reproved' ||
				this.content.group_training_user_result_status == 2
			)
				return 'red-5'
			else return 'blue-5'
		},

		useReviews() {
			const obj = this.getClientByIdClientSelected
			return obj ? obj.use_comments_group_training : false
		},

		hasCode() {
			const obj = this.getClientByIdClientSelected
			return this.course.code && this.course.code != 'null' && obj.use_group_training_code
				? true
				: false
		},
	},

	methods: {
		getArea(id) {
			const obj = this.country_areas.find((obj) => obj.value === id)
			return obj ? obj.label : ''
		},

		getGroup(id) {
			const obj = this.groups_user.find((obj) => obj.value === id)
			return obj ? obj.label : ''
		},

		openCourse() {
			if (!this.is_blocked && !this.checkTrailEnrolled) {
				if (!this.origin) this.$router.push({ name: 'course', params: { id: this.course.id } })
				else if (this.origin === 'trail')
					this.$router.push({
						name: 'trail_course',
						params: { id_trail: this.$route.params.id, id: this.course.id },
					})
			}
		},

		favoriteCourse() {
			if (!this.is_blocked && !this.checkTrailEnrolled) this.$emit('favorite', this.course.id)
		},

		likeCourse() {
			if (!this.is_blocked && !this.checkTrailEnrolled) this.$emit('like', this.course.id)
		},

		toggleReviews() {
			if (!this.is_blocked && !this.checkTrailEnrolled) this.$emit('review', this.course.id)
		},

		getImageError(event) {
			const obj = this.ClientSelected
			if (obj) {
				if (
					obj.group_training_placeholder !== 'https://image.jpg' &&
					obj.group_training_placeholder !== ''
				)
					event.target.src = obj.group_training_placeholder
				else event.target.src = 'placeholders/course.png'
			} else event.target.src = 'placeholders/course.png'
		},

		setClassHover(state) {
			if (this.is_blocked || this.checkTrailEnrolled) this.class_hover = 'disabled'
			else {
				if (state === 'mouseover') this.class_hover = 'shadow-5'
				else this.class_hover = ''
			}
		},
	},

	created() {
		if (this.is_blocked || this.checkTrailEnrolled) this.class_hover = 'disabled'
	},
}
</script>

<style lang="scss" scoped>
.title-course {
	font-size: 0.905rem;
	font-weight: 800;
	line-height: 1.2rem;
	min-height: 3.5rem;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.code-course {
	line-height: 1.5rem;
	min-height: 1.5rem;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.hoverable-icon {
	&:hover {
		color: #000;
	}
}
.q-img {
	.img {
		padding-bottom: 66%;
		img {
			position: absolute;
			top: 0;
			left: 0;
		}
	}
}
</style>
